import { A11yModule } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CourtSystemServiceModule, SharingRecordingsFeatureModule } from '@ftr/data-court-system'
import { CheckboxComponent, FormInputAutofocusDirective, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  AnchorComponent,
  AnimatedRemoteComponent,
  ButtonComponent,
  ErrorRetryComponent,
  IconComponent,
  LineLoaderComponent,
  LoaderComponent,
  ModalComponent,
  NotificationModule,
  PageComponent,
} from '@ftr/foundation'
import { TrmRepositoriesAndUploadsFeatureModule } from '@ftr/ui-admin'
import { HelpModule } from '@ftr/ui-help'
import { MfaRecoverAccountComponent } from '~app/features/multifactor-authentication/recover-account/mfa-recover-account.component'
import { RecoveryCodeModalContentComponent } from '~app/features/multifactor-authentication/recovery-code-modal/modal-content/recovery-code-modal-content.component'
import { MfaRequirementFormComponent } from '~app/features/multifactor-authentication/requirement/mfa-requirement-form.component'
import { MfaRequirementComponent } from '~app/features/multifactor-authentication/requirement/mfa-requirement.component'
import { MfaChallengeComponent } from './challenge/mfa-challenge.component'
import { RecoveryCodeModalComponent } from './recovery-code-modal/recovery-code-modal.component'
import { MfaSetupRequiredComponent } from './setup-required/mfa-setup-required.component'

@NgModule({
  declarations: [
    RecoveryCodeModalComponent,
    RecoveryCodeModalContentComponent,
    MfaRecoverAccountComponent,
    MfaChallengeComponent,
    MfaSetupRequiredComponent,
    MfaRequirementFormComponent,
    MfaRequirementComponent,
  ],
  imports: [
    CommonModule,
    ModalComponent,
    A11yModule,
    NotificationModule,
    ButtonComponent,
    IconComponent,
    AnchorComponent,
    RouterModule,
    HelpModule,
    ModalComponent,
    PageComponent,
    LineLoaderComponent,
    LoaderComponent,
    SharingRecordingsFeatureModule,
    TrmRepositoriesAndUploadsFeatureModule,
    CourtSystemServiceModule,
    CheckboxComponent,
    AnimatedRemoteComponent,
    ErrorRetryComponent,
    UntypedFormComponent,
    FormInputComponent,
    FormInputAutofocusDirective,
  ],
  exports: [
    RecoveryCodeModalComponent,
    MfaRecoverAccountComponent,
    MfaChallengeComponent,
    MfaRequirementFormComponent,
    MfaRequirementComponent,
    MfaSetupRequiredComponent,
  ],
})
export class MultiFactorAuthenticationModule {}
